(() => {
  window.swinger.observer.initialize('.swinger-widget', (elem) => {
    const type = elem.getAttribute('data-type').trim();
    const widgetSrc = `${window.swinger.config.assetsBase}/widgets/${type}${!window.swinger.supportsModules ? '.es5' : ''}.js?v=${window.swinger.config.version}`;

    window.swinger.resourceLoader.script(widgetSrc);
  }, false);

  window.swinger.observer.initialize('script[type="swinger/state"]', (elem) => {
    const id = elem.getAttribute('data-id').trim();
    const widgetElem = document.querySelector(`.swinger-widget[data-id="${id}"]`);
    const initialStateJSON = elem.textContent;
    const state = JSON.parse(initialStateJSON);

    if (!window.swinger.widgets.states[id]) {
      window.swinger.widgets.states[id] = state;
    } else {
      const previousState = window.swinger.widgets.stores[id].getState();
      const mergedState = Object.assign(previousState, state);

      window.swinger.widgets.stores[id].dispatch({
        type: 'UPDATE',
        value: mergedState,
      });
    }

    window.setTimeout(() => {
      elem.parentNode.removeChild(elem);
    });

    if (widgetElem) {
      window.swinger.eventHub.trigger(widgetElem, 'swinger-widget:store-updated');
    }
  }, false);
})();
